import { useState } from "react";
import { eventCards, eventCats } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

export default function EventGrid() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? eventCards : eventCards.filter((c) => c.cat === active);

  return (
    <section id="grid" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          index="03"
          kicker="事件档案"
          title="按类别翻看完整经过"
          desc="每张卡片都对应一段有始有终的完整档案，点进去能沿时间线逐节点回看前因后果，不会被带偏。"
          href="#method"
          linkLabel="了解梳理流程"
        />

        {/* category filter */}
        <div className="mb-8 flex flex-wrap items-center gap-2">
          {eventCats.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`cursor-pointer rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {c}
              {c !== "全部" && (
                <span
                  className={`ml-1.5 text-xs ${active === c ? "text-background-100" : "text-foreground-400"}`}
                >
                  {eventCards.filter((x) => x.cat === c).length}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* cards */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((c) => (
            <article
              key={c.title}
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <a href="#feature" className="block cursor-pointer">
                <div className="relative overflow-hidden">
                  <img
                    src={c.cover}
                    alt={c.title}
                    className="aspect-[4/3] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-primary-700 whitespace-nowrap backdrop-blur">
                    {c.cat}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {c.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {c.summary}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line" /> {c.views} 阅读
                    </span>
                    <span>{c.update}</span>
                    <span className="flex items-center gap-1 font-semibold text-primary-600 transition-transform group-hover:translate-x-0.5">
                      看始末 <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}